import React,{useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { toast } from "react-toastify";
import CardShortened from "../components/CardShortened";
import MiniCard from "../components/MiniCard";
import "./homeDashboard.css";
import { saveAs } from "file-saver";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Col,
  Input,
  Label,
} from "reactstrap";
import Select from "react-select";
import contractService from "../../../services/contract/contractService";
function HomeDashboard() {
   const location = useLocation()
  const history = useHistory();
  const idcustomer = JSON.parse(localStorage.getItem("user")).id
  const [listContratCarte, setListContratCarte] = useState(null);
  const [selectOptionContrat, setOptionSelectedContrat] = useState(null);
  const [optionContrat, setListOptionContrat] = useState([]);
  const [contractId, setContratId]= useState(null)
  const [oppenn, setOppenn] = useState(false);
  const [blockCarteVente,setBlockCarteVente] = useState(false)

      const modaltoggle1 = () => {
        setOppenn(!oppenn);
      };

  

   useEffect(()=>{
      contractService.getAllCarteContractsbyCustomer(idcustomer).then((res)=>{
        if(res.status == 200){
          setListContratCarte(res.data)
        }
      })
  
    },[])
  
      const onchangeSelectContart =(item)=>{
        setOptionSelectedContrat(item)
        contractService.getContractbyId(item.value).then(res=>{
          setContratId(res.data)
        })
        
      }
  const Deconnecté = () => {
    localStorage.clear();
    history.push("/");
  };

  const saveFile = () => {
      saveAs(
        `${process.env.PUBLIC_URL}/assets/pdf/NOTICE D'INFORMATION CARTE ASSUR MAX (2).pdf`,
        "NOTICE D'INFORMATION CARTE ASSUR MAX.pdf"
      );
  };
  const continuer = ()=>{
        if(contractId.formula.nbrProductCovered === contractId.number_of_products){
         
           history.push({
          pathname: "/informationCarte",
          state: contractId,
          });

        }else{
          history.push({
          pathname: "/Souscription/Etape2",
          state: contractId,
          });

        }
   }

  const addproduct = () => {
    setListOptionContrat(
              listContratCarte?.map((el) => ({
                value: el.idcontract,
                label:el.numero_carte_garanty

              }))
            );
            setOppenn(true)
  };
  const contarct = () => {
    history.push("/dashboard/contract");
  };
  const sinistre = () => {
    history.push("/dashboard/sinistre");
  };
  const remboursement = () => {
    history.push("/dashboard/rembourssement");
  };
  const monCompte = () => {
    history.push("/dashboard/mon-compte");
  };
   const [oppen, setOppen] = useState(location.state);
    const modaltoggle = () => {
      setOppen(!oppen);
    };
  return (
    <>
      <div className="home">
        <MiniCard
          onClick={addproduct}
          text="Ajouter un équipement"
          // text="My Insured Objects"
          icon={`${process.env.PUBLIC_URL}/assets/images/add-product.svg`}
          color="rgb(224 2 199 / 74%)"
        />
        <MiniCard
          onClick={contarct}
          text="Mes Objets assurés"
          // text="My Insured Objects"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-1.svg`}
          color="#F9F4E1"
        />
        <MiniCard
          onClick={sinistre}
          text="Mes Sinistres"
          // text="My Sinisters"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-2.svg`}
          color="#FBEDE8"
        />
        <MiniCard
          onClick={remboursement}
          text="Mes Remboursements"
          // text="My Refunds"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-3.svg`}
          color="#EAF9F1"
        />
        <MiniCard
          onClick={monCompte}
          text="Mon Compte"
          // text="My Account"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-3.svg`}
          color="#F9EAF9"
        />
        <MiniCard
          onClick={() => {
            history.push("/");
          }}
          text="Garantie Smartphone"
          // text="Smartphone Warranty"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-c-1.svg`}
          color="#F9F4E1"
        />
        <MiniCard
          onClick={() => {
            toast.info("Prochainement disponible");
          }}
          text="Garantie Multimedia"
          // text="Multimedia Guarantee"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-2.svg`}
          color="#FBEDE8"
        />
        <MiniCard
          onClick={() => {
            toast.info("Prochainement disponible");
          }}
          text="Garantie Électroménager"
          // text="Home Appliance Warranty"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-c-3.svg`}
          color="#EAF9F1"
        />
        <MiniCard
          onClick={() => {
            history.push({
              pathname: "/",
              state: ["Optique", "b460b428-82b2-46a0-8877-400cf5377770"],
            });
          }}
          text="Garantie Optique"
          // text="Optical Warranty"
          icon={`${process.env.PUBLIC_URL}/assets/images/dash-c-4.svg`}
          color="#F9EAF9"
        />
      </div>
      <div className="home">
      </div>
      <div className=" home" style={{ marginTop: "50px" }}>
        <CardShortened
          color="#E5F0FC"
          icon={`${process.env.PUBLIC_URL}/assets/images/doc-icon.svg`}
          text={"Mes documents"}
          // text="My documents"
          onClick={()=>{history.push("/dashboard/mes-documents");}}
        />
        {/* <CardShortened
          color="#E5F0FC"
          icon={`${process.env.PUBLIC_URL}/assets/images/Groupe 333.svg`}
          text={"Réclamation"}
          onClick={()=>{history.push("/dashboard/Reclamation");}}
        /> */}
        <CardShortened
          color="#E5F0FC"
          icon={`${process.env.PUBLIC_URL}/assets/images/Groupe 201.svg`}
          text={"Notice d'information"}
          // text="Help"
          onClick={saveFile}
        />
        <CardShortened
          color="red"
          icon={`${process.env.PUBLIC_URL}/assets/images/logout copy.svg`}
          text={"Déconnexion"}
          // text={"Logout"}
          textColor="white"
          onClick={Deconnecté}
        />

        <Modal
        isOpen={oppen}
        toggle={modaltoggle}
        centered
        style={{ display: "flex", justifyContent: "center", maxWidth: "750px" }}
      >
        <ModalHeader toggle={modaltoggle}>
          <div
            style={{
              font: "normal normal bold 25px/27px Century Gothic",
              color: "#0C015F",
            }}
          >
            Félicitations ! Votre produit a été ajouté avec succès à votre carte d’assurance.
          </div>
        </ModalHeader>
      </Modal>
      { blockCarteVente ? <Modal
        isOpen={oppenn}
        toggle={modaltoggle1}
        centered
        style={{ display: "flex", justifyContent: "center", maxWidth: "750px" }}
      >
        <ModalHeader toggle={modaltoggle1}>
        </ModalHeader>
        <ModalBody>
          <div className="form-row">
               <div
            style={{
              font: "normal normal bold 25px/27px Century Gothic",
              color: "#bf0303",
            }}
          >
            Vous avez atteint le nombre maximum de produits sur la carte AssurMax numéro : {contractId.numero_carte_garanty}
          </div>
          </div>
        </ModalBody>
        <ModalFooter>
          {/* <Button
            onClick={continuer}
            className="calcule-btn"
            style={{ width: "30%" }}
          >
            Continuer
          </Button> */}
          <br />
        </ModalFooter>
      </Modal> : 
      <Modal
        isOpen={oppenn}
        toggle={modaltoggle1}
        centered
        style={{ display: "flex", justifyContent: "center", maxWidth: "750px" }}
      >
        <ModalHeader toggle={modaltoggle1}>
          <div
            style={{
              font: "normal normal bold 25px/27px Century Gothic",
              color: "#0C015F",
            }}
          >
            {/* Before continuing, you must select your card */}
            Votre carte Assurmax ou Assurmax+
          </div>
        </ModalHeader>
        <ModalBody>
          <div className="form-row">
            <Col md="8 mb-4" className="inputCarte">
              <Col
                md={{
                  size: 10,
                }}
              >
                <Label check className="text-popup">
                  Sélectionnez votre carte
                  {/* Select your card */}
                </Label>
                <Select
                  value={selectOptionContrat}
                  onChange={onchangeSelectContart}
                  options={optionContrat}
                />
              </Col>
            </Col>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={continuer}
            className="calcule-btn"
            style={{ width: "30%" }}
          >
            Continuer
            {/* Next */}
          </Button>
        </ModalFooter>
      </Modal>}
      </div>
    </>
  );
}

export default HomeDashboard;
